import { DateSelectArg, EventContentArg, EventDropArg } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin, { EventResizeDoneArg } from '@fullcalendar/interaction';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import { shallowEqual } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import useAsyncGetScheduleCalendarEvents from '../../../../hooks/useAsyncGetScheduleCalendarEvents';
import { CalendarEventsStatus } from '../../../../sic-lib/enums/CalendarEventsStatus';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import FullCalendarEventContent from '../../FullCalendarEventContent/FullCalendarEventContent';

const useStyles = makeStyles()(theme => ({
    root: {
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        position: 'relative',
        paddingBottom: theme.spacing(2),
    },
    actions: {
        padding: theme.spacing(1),
    },
    calendarWrapper: {
        height: '100%',
    },
    calendar: {
        //height: '100%',
        //padding: theme.spacing(1),
        //boxSizing: 'content-box'
        //overflow: 'hidden'
    },
}));

interface Props {
    onCloseHandler: () => void;
}

interface RangeApi {
    start: Date;
    end: Date;
    startStr: string;
    endStr: string;
}

export default function DrawerCalendarSchedule({ onCloseHandler }: Props) {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    //fitting the calendar into the drawer
    const calendarWrapperRef = React.useRef<HTMLDivElement | null>(null);

    React.useEffect(() => {
        if (calendarWrapperRef.current) {
            const { height } = calendarWrapperRef.current.getBoundingClientRect();

            setCalendarHeight(height);
        }
    }, []);

    const [calendarHeight, setCalendarHeight] = React.useState<number>(0);
    //console.log('calendarHeight', calendarHeight);

    const appState = useAppSelector(state => {
        return {
            calendarEventsStatus: CalendarEventsStatus.none,
        };
    }, shallowEqual);

    const { requestStatus, getContactCalendarEventsResult, asyncGetCalendarEventsByRange } =
        useAsyncGetScheduleCalendarEvents();

    const [range, setRange] = React.useState<RangeApi>();

    //request the events
    const requestEvents = async (rangeInfo: RangeApi) => {
        setRange(rangeInfo);
        asyncGetCalendarEventsByRange(rangeInfo.start, rangeInfo.end, null);
    };

    React.useEffect(() => {
        if (appState.calendarEventsStatus == CalendarEventsStatus.shouldRefresh && range) {
            asyncGetCalendarEventsByRange(range.start, range.end, null);
        }
    }, [appState.calendarEventsStatus]);

    //selecting an empty slot in the calendar triggers opening the create event drawer
    const onNewSlotSelect = (data: DateSelectArg) => {
        // dispatch(
        //     calendarActions.openDrawerNewCalendarEvent({
        //         allDay: data.allDay,
        //         startDate: DateTime.fromJSDate(data.start),
        //         endDate: DateTime.fromJSDate(data.end),
        //         title: '',
        //     }),
        // );
    };

    const onEventDroppedOrResized = (eventInfo: EventDropArg | EventResizeDoneArg) => {
        const calendarEvent = getContactCalendarEventsResult.find(
            x => x.eventId == +eventInfo.event.id,
        );
        //calendarEvent can be null when "dragging to create" a new one
        if (calendarEvent && eventInfo.event.start && eventInfo.event.end) {
            // dispatch(
            //     calendarActions.updateCalendarEvent(
            //         calendarEvent.eventId,
            //         mapCalendarEventRequest({
            //             ...calendarEvent,
            //             startDate: DateTime.fromJSDate(eventInfo.event.start),
            //             endDate: DateTime.fromJSDate(eventInfo.event.end),
            //         }),
            //     ),
            // );
        }
    };

    return (
        <React.Fragment>
            <Grid container direction="column" wrap="nowrap" className={classes.root}>
                {/*<Grid container justifyContent='flex-end' alignItems='center' className={classes.actions}>*/}
                {/*    <Grid item xs='auto'>*/}
                {/*        <ButtonGroup variant="contained" color="primary">*/}
                {/*            <Button size="small">Cancel</Button>*/}
                {/*            <Button size="small" color="primary">Save</Button>*/}
                {/*        </ButtonGroup>*/}
                {/*    </Grid>*/}
                {/*</Grid>*/}
                <Grid item className={classes.calendarWrapper} ref={calendarWrapperRef}>
                    <FullCalendar
                        themeSystem="materia"
                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                        initialView="timeGridWeek"
                        height={calendarHeight}
                        firstDay={0}
                        allDaySlot={true}
                        editable={true}
                        selectable={true}
                        selectMirror={true}
                        weekends={false}
                        select={onNewSlotSelect}
                        events={getContactCalendarEventsResult}
                        datesSet={requestEvents}
                        eventDrop={onEventDroppedOrResized}
                        eventResize={onEventDroppedOrResized}
                        eventContent={(calendarEvent: EventContentArg) => (
                            <FullCalendarEventContent
                                fcCalendarEvent={calendarEvent}
                                allEvents={getContactCalendarEventsResult}
                            />
                        )}
                    />
                </Grid>
                {/*<Grid item xs='auto'>*/}
                {/*    <h1>Some Footer Things</h1>*/}
                {/*</Grid>*/}
            </Grid>
        </React.Fragment>
    );
}
